// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e23f1bc8","82":"13e0b22e","244":"adab59b5","787":"ed070baf","866":"287e0166","917":"a61b944a"}[chunkId] + ".chunk.js";
};